// @ts-check

class BeckCopyCitation extends HTMLElement {
	#copyButton;
	#toggleButton;

	constructor() {
		super();
	}

	connectedCallback() {
		this.#copyButton = this.querySelector(".js-Citation-copyButton");
		this.#toggleButton = this.querySelector(".js-Citation-toggle");

		if (!this.#copyButton || !this.#toggleButton) {
			return;
		}

		this.#addEventListeners();
	}

	#addEventListeners() {
		this.#toggleButton.addEventListener(
			"click",
			this.#handleToggleButtonClick.bind(this),
		);

		this.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				this.#closeCitation();
			}
		});

		document.addEventListener("click", (event) => {
			const target = /** @type {HTMLElement} */ (event.target);
			if (target !== this && !this.contains(target)) {
				this.#closeCitation();
			}
		});

		this.#copyButton.addEventListener(
			"click",
			this.#handleCopyButtonClick.bind(this),
		);
	}

	#closeCitation() {
		const card = /** @type {HTMLDivElement} */ (
			this.querySelector(".js-Citation-card")
		);
		if (!card) {
			return;
		}
		// Only focus the toggle button if the card was actually visible
		const wasVisible = !card.hidden;
		card.hidden = true;
		if (wasVisible) {
			this.#toggleButton.focus();
		}
	}

	#handleToggleButtonClick() {
		const card = /** @type {HTMLDivElement} */ (
			this.querySelector(".js-Citation-card")
		);

		if (!card) {
			return;
		}

		card.toggleAttribute("hidden");

		// Focus the card after browser completed layout re-rendering
		// caused by toggleAttribute("hidden")
		requestAnimationFrame(() => {
			card.focus();
		});
	}

	async #handleCopyButtonClick(event) {
		const button = event.currentTarget;
		const buttonLabel = button.querySelector(".Button-label");
		const buttonText = buttonLabel.textContent;
		const citationText = this.querySelector(".Card-content");

		if (!citationText) {
			return;
		}

		try {
			await navigator.clipboard.writeText(citationText.textContent);
			buttonLabel.textContent = button.dataset.copied;

			setTimeout(() => {
				buttonLabel.textContent = buttonText;
			}, 2000);
		} catch (error) {
			throw new Error("Failed to copy citation text", { cause: error });
		}
	}
}

customElements.define("beck-copy-citation", BeckCopyCitation);
